import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductDetailsInStore extends Component {
  /** @type {AbortController | undefined} */
  #activeFetch;

  /** @type {(event: VariantUpdateEvent) => void} */
  #variantUpdated = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productUrl = event.detail.data.newProduct.url;
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.detail.data.productId &&
      event.detail.data.productId !== this.dataset.productId
    ) {
      return;
    }

    const variantId = event.detail.resource ? event.detail.resource.id : null;

    if (!variantId || variantId === this.dataset.variantId) return;

    this.dataset.variantId = variantId;

    const blockId = this.dataset.blockId;
    if (blockId && event.detail.data.html) {
      const updated = event.detail.data.html.querySelector(
        `product-details-in-store[data-block-id="${blockId}"]`
      );

      if (updated) {
        morph(this, updated);
        return;
      }
    }

    if (this.dataset.sectionId) {
      this.#fetchAvailability(variantId);
    }
  };

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.#variantUpdated);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#variantUpdated);
  }

  #createAbortController() {
    if (this.#activeFetch) this.#activeFetch.abort();
    this.#activeFetch = new AbortController();
    return this.#activeFetch;
  }

  /**
   * Fetches updated in-store pickup availability for a variant.
   * @param {string} variantId - The ID of the variant to fetch availability for.
   */
  #fetchAvailability = (variantId) => {
    if (!variantId) return;

    const abortController = this.#createAbortController();
    const url = this.dataset.productUrl;

    fetch(`${url}?variant=${variantId}&section_id=${this.dataset.sectionId}`, {
      signal: abortController.signal,
    })
      .then((response) => response.text())
      .then((text) => {
        if (abortController.signal.aborted) return;

        const html = new DOMParser().parseFromString(text, 'text/html');
        const wrapper = html.querySelector(`product-details-in-store[data-variant-id="${variantId}"]`);

        if (wrapper) {
          morph(this, wrapper);
        }
      })
      .catch((_error) => {
        if (abortController.signal.aborted) return;
      });
  };
}

if (!customElements.get('product-details-in-store')) {
  customElements.define('product-details-in-store', ProductDetailsInStore);
}
